import { useReactiveVar } from '@apollo/client';
import Paper from '@mui/material/Paper';
import Box from '@mui/material/Box';
import RequestForm from './RequestForm';
import Copyright from '../../../components/common/Copyright';
import Version from '../../../components/common/Version';

import { newRequestState } from '../common';
import ReviewPage from './ReviewPage';
import React from 'react';
import ServiceForm from './ServiceForm';
import { RequestPageProps } from '../../../types';
import { isTransfer, isBillPay } from '../../../util/transaction';

const RequestPage = ({ requestType = 'TRANSFER' }: RequestPageProps) => {
  const pageState = useReactiveVar(newRequestState);
  React.useEffect(() => {
    newRequestState('input');
  }, []);

  return (
    <Box sx={{ width: 'auto', ml: 'auto', mr: 'auto', maxWidth: 700 }}>
      <Paper sx={{ mt: 3, mb: 3, padding: 2 }}>
        {/* {submitted && (
          <ConfirmPage code={confirmationCode} onSubmit={onCloseConfirmCode} />
        )}*/}
        {pageState === 'review' && <ReviewPage />}
        {pageState === 'input' && isTransfer(requestType) && <RequestForm />}
        {pageState === 'input' && isBillPay(requestType) && <ServiceForm />}
      </Paper>
      <Copyright year={new Date().getFullYear()} />
      <Version />
    </Box>
  );
};

export default RequestPage;
